import React from 'react';


import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

interface GuidedPromptFooterProps {
  isMultiStep: boolean;
  currentStep: number;
  isLastStep: boolean;
  isRequired: boolean;
  canProceed: boolean;
  onPrevious: () => void;
  onSkip: () => void;
}

const GuidedPromptFooter = ({
  isMultiStep,
  currentStep,
  isLastStep,
  isRequired,
  canProceed,
  onPrevious,
  onSkip,
}: GuidedPromptFooterProps): React.JSX.Element => (
  <Stack
    direction="row"
    sx={[
      {
        alignItems: 'center',
        justifyContent: 'flex-start',
        px: 2,
        pt: 1.25,
        pb: 1.75,
        borderTopWidth: '1px',
        borderColor: 'tokens.gray.100',
      },
      isMultiStep && { justifyContent: 'space-between' },
    ]}
  >
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5 }}>
      {isMultiStep && currentStep > 0 && (
        <Button
          type="button"
          variant="neutral-text"
          size="sm"
          onClick={onPrevious}
        >
          Back
        </Button>
      )}
      {!isMultiStep && (
        <Button
          type="submit"
          variant="reserve-filled"
          size="sm"
          disabled={!canProceed}
          title={!canProceed ? 'Answer required to continue' : undefined}
        >
          Submit
        </Button>
      )}
    </Stack>

    {isMultiStep && (
      <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5 }}>
        {!isRequired && !isLastStep && (
          <Button
            type="button"
            variant="neutral-text"
            size="sm"
            onClick={onSkip}
          >
            Skip
          </Button>
        )}
        <Button
          type="submit"
          variant="reserve-filled"
          size="sm"
          disabled={!canProceed}
          title={!canProceed ? 'Answer required to continue' : undefined}
        >
          {isLastStep ? 'Submit' : 'Next'}
        </Button>
      </Stack>
    )}
  </Stack>
);

export default GuidedPromptFooter;
